import React from 'react';
import { Pulse, WifiSlash } from '@phosphor-icons/react';
import { useI18n } from '../../contexts/I18nContext';
import { combinedState, latestIso } from '../../lib/movement';
import { formatSince } from '../../lib/time';

const DOWN = ['silent', 'never_reported', 'no_motion_data'];

// Always-visible "Movement monitoring: active / not reporting since 14:05" line.
export function MonitoringStatus({ devices, testid = 'movement-monitoring-status' }) {
  const { t, lang } = useI18n();
  if (!devices?.length) return null;
  const down = DOWN.includes(combinedState(devices));
  const last = latestIso(devices.map((d) => d.last_sample_at || d.device_last_seen_at));
  const value = !down ? t('mon_active') : last ? t('mon_down_since', { time: formatSince(last, lang) }) : t('mon_down');
  const Icon = down ? WifiSlash : Pulse;
  return (
    <div
      data-testid={testid}
      data-state={down ? 'down' : 'active'}
      className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-sm border ${down ? 'bg-amber_warn-100/40 border-amber_warn-100 text-[#8a6326]' : 'bg-sage-50 border-sage/20 text-sage-700'}`}
    >
      <Icon size={15} weight="bold" />
      <span className="font-medium">{t('mon_label')}:</span>
      <span>{value}</span>
    </div>
  );
}
